import { USER_PAGE_ERROR, USER_PAGE_REQUESTED,USER_PAGE_RECEIVED } from "../actions/userPage";
import RequestState from "../storage/RequestState";
import RequestResult from "../storage/RequestResult";
import {EMPTY_REQUEST_RESULT_INIT_STATE} from "../utils/JsObjectHelper";

/**
*
* @param {RequestResult} state
* @param {BaseAction|ReceiveEntryTypesAction|ReceiveErrorAction} action
* @return {RequestResult}
*/
export const userpage = (state = EMPTY_REQUEST_RESULT_INIT_STATE, action)  => {

switch (action.type) {
   case USER_PAGE_REQUESTED:
       return new RequestResult(RequestState.getInstanceLoading(), state.data);
   case USER_PAGE_RECEIVED:
       return new RequestResult(RequestState.getInstanceDone(), action.userpage, action.receivedAt);
   case USER_PAGE_ERROR:
       return new RequestResult(
           RequestState.getInstanceError(
               action.errorResponseStatusCode,
               action.errorResponseMessage ? action.errorResponseMessage : null
           ),
           state.getData()
       );
 
   default:
       return state
}
};
